/**
 * Edit Controller
 */
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

  app.controller('CampaignEditController', [
    '$scope',
    '$window',
    '$compile',
    'campaignApi',
    'insertionOrderApi',
    'advertiserApi',
    'optionsApi',
    'agencyApi',
    function(
      $scope,
      $window,
      $compile,
      campaignApi,
      insertionOrderApi,
      advertiserApi,
      optionsApi,
      agencyApi,
    ) {
      if (window.localStorage.getItem('advancedMode')) {
        $scope.advancedMode = true;
        $scope.tab = 'all';
      }

      var watchInventory = function() {
        $scope.$watch(
          'campaign.dvt_whitelist',
          function(newVal, oldVal) {
            if (newVal != oldVal) {
              $scope.campaign.inventory = [];
              $scope.fetchInventory();
            }
          },
          true
        );

        $scope.$watchGroup(['campaign.start', 'campaign.end'], function(
          newVals
        ) {
          if (newVals[0] && newVals[1]) {
            $scope.fetchInventory();
          }
        });
      };
      $scope.tab = 'basic';

      $scope.$watch('advancedMode', function(newVal) {
        if (newVal) {
          $scope.tab = 'all';
          window.localStorage.setItem('advancedMode', 'all');
        } else {
          $scope.tab = 'basic';
          if (window.localStorage.getItem('advancedMode')) {
            window.localStorage.removeItem('advancedMode');
          }
        }
      });

      // init values
      $scope.campaign = {
        _advertiserId: false,
        _agencyId: null,
        _userId: null,
        delivery_mode: 3,
        campaign_optimization_dsperformance_mode: 'none',
        campaign_optimization_dsperformance_limit: 0,
        inventory: [],
        dvt: 1,
        contacts: [],
        country_blacklist: [],
        country_whitelist: [],
        region_blacklist: [],
        region_whitelist: [],
        city_blacklist: [],
        city_whitelist: [],
        isp_whitelist: [],
        isp_blacklist: [],
        dvt_whitelist: [],
        os_whitelist: [],
        os_blacklist: [],
        speed_whitelist: [],
        day_hour_whitelist: [],
        day_hour_blacklist: [],
        week_day_whitelist: [],
        week_day_blacklist: [],
        lang_whitelist: [],
        lang_blacklist: [],
        dta_profiles_whitelist: [],
        dta_profiles_blacklist: [],
        iab_topic_id_whitelist: [],
        iab_topic_id_blacklist: [],
        priority: 3,
        leads_days: 30,
        leads_cpm: 0.00,
        leads: [],
        ileads: [],
        fc_cap: 0,
        type: '',
        imps_actual: 0,
        avoidBLContext: '0',
        campaign_optimization_urgency_status: false,
        timezone: window.tz ? window.tz : "Europe/Berlin",

      };

      $scope.campaign_doc = [];

      $scope.availableBudget = { total: 1000000, daily: 100000 };
      $scope.creativesComplete = false;
      $scope.detectUnselectItems = false;

      $scope.log = {
        count: 0,
        data: [],
      };

      $scope.closeCampaignForm = false;
      $scope.msgSaved = '';

      $scope.now = moment
        .utc()
        .seconds(0)
        .milliseconds(0)
        .valueOf();

      var getMinStartDate = function() {
        return null;//$scope.now;
      };

      var getMaxStartDate = function() {
        return null;
      };



      campaignApi.getLeadUrlPattern().then(
          function(data){
              $scope.leadUrlPattern = decodeURI(data.leadUrlPattern);
          },
          function() {
              console.error('could not load lead url pattern');
          }
      );


      var getMinEndDate = function() {
        var minEnd = $scope.now;
        if ($scope.campaign && $scope.campaign.start) {
            minEnd = Math.max($scope.campaign.start, minEnd);
        }
        return minEnd;
      };

      var getMaxEndDate = function() {
        return null;
      };

      $scope.$watchGroup(['io', 'campaign.start', 'campaign.end'], function(
        newVals
      ) {
        $scope.minStart = getMinStartDate();
        $scope.maxStart = getMaxStartDate();
        $scope.minEnd = getMinEndDate();
        $scope.maxEnd = getMaxEndDate();
      });

      // load campaign from server
      if (window.campaignId) {
        campaignApi.read(window.campaignId).then(
          function(data) {
            $scope.campaign = data.campaign;
            $scope.log = data.log;
            $scope.campaign_doc = data.doc;

            $scope.campaign.active = $scope.campaign.active === 1;

            if ($scope.campaign.country_blacklist.length > 0) {
              $scope.cntrList = 'bl';
            }

            if ($scope.campaign.country_whitelist.length > 0) {
              $scope.cntrList = 'wl';
            }

             if ($scope.campaign.region_blacklist.length > 0) {
                $scope.regionList = 'bl';
             }

             if ($scope.campaign.region_whitelist.length > 0) {
                $scope.regionList = 'wl';
             }


            if ($scope.campaign.city_blacklist.length > 0) {
                $scope.cityList = 'bl';
             }

            if ($scope.campaign.city_whitelist.length > 0) {
              $scope.cityList = 'wl';
            }

            if ($scope.campaign.lang_whitelist === undefined) {
                $scope.campaign.lang_whitelist = [];
            }
            if ($scope.campaign.lang_blacklist === undefined) {
                $scope.campaign.lang_blacklist = [];
            }

            if ($scope.campaign.lang_blacklist.length > 0) {
                $scope.langList = 'bl';
            }

            if ($scope.campaign.lang_whitelist.length > 0) {
                $scope.langList = 'wl';
            }

            if ($scope.campaign.zip_blacklist) {
              $scope.zipList = 'bl';
            }

            if ($scope.campaign.zip_whitelist) {
              $scope.zipList = 'wl';
            }

            if ($scope.campaign.dta_profiles_blacklist.length > 0) {
               $scope.dtaList = 'bl';
            }

            if ($scope.campaign.dta_profiles_whitelist.length > 0) {
                $scope.dtaList = 'wl';
            }


            if ($scope.campaign.isp_blacklist.length > 0) {
              $scope.ispList = 'bl';
            }

            if ($scope.campaign.isp_whitelist.length > 0) {
              $scope.ispList = 'wl';
            }

            if ($scope.campaign.day_hour_blacklist.length > 0) {
                $scope.dayHourList = 'bl';
            }

            if ($scope.campaign.day_hour_whitelist.length > 0) {
                $scope.dayHourList = 'wl';
            }

              if ($scope.campaign.week_day_blacklist.length > 0) {
                  $scope.weekDayList = 'bl';
              }

              if ($scope.campaign.week_day_whitelist.length > 0) {
                  $scope.weekDayList = 'wl';
              }

              if ($scope.campaign.os_blacklist.length > 0) {
                  $scope.osList = 'bl';
              }

              if ($scope.campaign.os_whitelist.length > 0) {
                  $scope.osList = 'wl';
              }

            if ($scope.campaign.iab_topic_id_blacklist.length > 0) {
                $scope.iabTopicIdList = 'bl';
            }

            if ($scope.campaign.iab_topic_id_whitelist.length > 0) {
                $scope.iabTopicIdList = 'wl';
            }



            if ($scope.campaign.leads.length > 0) {
                $scope.campaign.leads.forEach(function(lead, i) {
                    generateLeadTrackingUrl(lead, i+1)
                });
                $scope.showLead = true;
            }

            if ($scope.campaign.ileads.length > 0) {
                $scope.campaign.ileads.forEach(function(lead, i) {
                    generateLeadTrackingUrl(lead, i+50)
                });
                $scope.showILead = true;
            }




              $scope.fetchInventory();
            watchInventory();
            
            campaignApi.getCampaignStat([$scope.campaign._id]).then(
              function(stat) {

                var stat_hash = {};
                for (var i=0; i<stat.length; i++) {
                  stat_hash[stat[i]['cid']] = stat[i];
                }
                $scope.campaign.imps_actual = stat_hash[$scope.campaign._id] ? stat_hash[$scope.campaign._id].n_impression : 0;

                if ($scope.campaign.imps_actual > 999) {
                  // start date readonly if at least 1000 imp has been delivered in all assigned campaigns
                  $scope.startDateTitle = 'You cannot change the start date, because ' + $scope.campaign.imps_actual + ' impressions have been delivered.';
                  $scope.startTimeTitle = 'You cannot change the start time, because ' + $scope.campaign.imps_actual + ' impressions have been delivered.';
                  $scope.startDisabled = true;
                }
              }
            );

          },
          function() {
            console.error('could not load campaign');
          }
        );
      } else if (!window.campaignId && window.advertiserId) {
        // for new ios inherit advertiser from client selection if set
        $scope.campaign._advertiserId = window.advertiserId;
        watchInventory();
      } else {
        watchInventory();
      }

      $scope.options = {
        fc: [
          {
            name: 'Hourly',
            value: 3600,
          },
          {
            name: 'Daily',
            value: 86400,
          },
          {
            name: 'Weekly',
            value: 604800,
          },
          {
            name: 'Monthly',
            value: 2592000,
          },
        ],
        leadServerCallTypes: [
            {
              name: 'Server2Server call',
              value: '0'
            },
            {
              name: 'NOT Server2Server call',
              value: '1'
            }
        ]
      };

      // load goal options
      optionsApi.getGoals().then(
        function(data) {
          $scope.options.goal = data;
        },
        function() {
          console.error('could not load goals');
        }
      );

        // load langs options
        optionsApi.getLangs().then(
            function(data) {
                $scope.options.langs = data;
            },
            function() {
                console.error('could not load langs');
            }
        );

        optionsApi.getDsperformanceMode().then(
            function(data) { $scope.options.dsperformance_mode = data; },
            function() { console.error('could not load dsperformance mode'); }
        );

        optionsApi.getLeadTypes().then(
            function(data) {
                $scope.options.leadTypes = data;
            },
            function() {
                console.error('could not load leadTypes');
            }
        );

      optionsApi.getDelivery().then(
        function(data) {
          $scope.options.delivery = data;
        },
        function() {
          console.error('could not load delivery');
        }
      );

      optionsApi.getOs().then(
        function(data) {
          $scope.options.os = data;
        },
        function() {
          console.error('could not load delivery');
        }
      );

      optionsApi.getDevices().then(
        function(data) {
          $scope.options.device = data;
        },
        function() {
          console.error('could not load delivery');
        }
      );

      optionsApi.getSpeed().then(
        function(data) {
          $scope.options.speed = data;
        },
        function() {
          console.error('could not load delivery');
        }
      );

      optionsApi.getDayHour().then(
        function(data) {
          $scope.options.day_hour = data;
        },
        function() {
          console.error('could not load delivery');
        }
      );

        optionsApi.getWeekDay().then(
            function(data) {
                $scope.options.week_day = data;
            },
            function() {
                console.error('could not load week_day');
            }
        );

       optionsApi.getIab(true, true, true).then(
            function(data) {
                $scope.options.iabCat = data;
            },
            function() {
                console.error('could not load IABCat');
            }
        );

      var disableDateChanging = function() {
        $scope.startDisabled = true;
        $scope.endDisabled = true;

        $scope.startDateTitle =
          'The IO has expired, so the campaign start date cannot be changed.';
        $scope.startTimeTitle =
          'The IO has expired, so the campaign start time cannot be changed.';
        $scope.endDateTitle =
          'The IO has expired, so the campaign end date cannot be changed.';
        $scope.endTimeTitle =
          'The IO has expired, so the campaign end time cannot be changed.';
      };

      $scope.$watch('campaign._insertionOrderId', function(ioId) {
        if (!ioId) {
          return;
        }

        $scope.io = null;

        // $scope.availableBudget = {total:0, daily:0};

        insertionOrderApi.read(ioId).then(
          function(data) {
            if ($scope.campaign.imps_actual ===  0) {
              $scope.startDisabled = false;
              $scope.startDateTitle = '';
              $scope.startTimeTitle = '';
            }

            $scope.endDisabled = false;
            $scope.ioInvalid = false;
            $scope.ioExpired = false;
            $scope.endDateTitle = '';
            $scope.endTimeTitle = '';

            if (
              data.io.end < moment().unix() * 1000 &&
              $scope.campaign._insertionOrderId
            ) {
              $scope.ioInvalid = 'The IO has expired.';
              $scope.ioExpired = true;
              disableDateChanging();
            }

            if (
              data.io.end < moment().unix() * 1000 &&
              $scope.campaign._insertionOrderId &&
              !$scope.campaign._id
            ) {
              $scope.ioInvalid =
                "The IO has expired. It's not possible to create a campaign.";
              $scope.ioExpired = true;
              disableDateChanging();
            }

            $scope.io = data.io;

            // force re-validation
            validateCampaign();

          },
          function() {
            console.error('could not load io');
          }
        );
      });

      $scope.getRemainingBudgets = function() {
        return {
          total:
            $scope.availableBudget.total - ($scope.campaign.budget_total || 0),
          daily:
            $scope.availableBudget.daily - ($scope.campaign.budget_daily || 0),
        };
      };

      $scope.$watch('campaign._advertiserId', function(advertiserId) {
        if (!advertiserId) {
          $scope.campaign._insertionOrderId = undefined;
          return;
        }

        $scope.ioInvalid = false;
        $scope.io = null;
        $scope.ioOptions = [];

        // @todo filter by selected advertiser or given advertifer (head)
        insertionOrderApi
          .getList(
            { field: 'name', order: 'asc' },
            '',
            { number: 0, size: -1 },
            advertiserId
          )
          .then(
            function(ios) {
              var ioOpts = [];
              $scope.io_full = [];
              ios.data.forEach(function(io) {
                ioOpts.push({
                  name: io.name,
                  value: io._id,
                });
                $scope.io_full[io._id] = io;
              });

              $scope.ioOptions = ioOpts;
            },
            function() {
              console.error('could not load IOs');
            }
          );
      });

      var validateCampaign = function() {
        // basics validation
        $scope.basicsComplete =
          $scope.campaignForm &&
          $scope.campaignForm.name.$valid &&
          $scope.campaign.start &&
          $scope.campaign.end &&
          $scope.campaign._advertiserId &&
          $scope.campaign._insertionOrderId &&
          $scope.campaign.budget_total &&
          $scope.campaign.budget_daily &&
          $scope.campaign.cpm_max;

        // delivery validation
        $scope.deliveryComplete =
          $scope.campaign.goal_type &&
          $scope.campaign.delivery_mode &&
          $scope.campaign.fc_expire &&
          $scope.campaign.goal_value &&
          $scope.campaign.fc_cap !== undefined;

        // targeting validation
        $scope.targetingComplete = $scope.deliveryComplete;

        $scope.inventoryComplete =
          $scope.campaign.inventory.length > 0 &&
          $scope.inventoryCovered != false;

        // $scope.creativesComplete = true;

        $scope.everythingComplete = (function() {
          var valid = true;

          // if edited crative is required else not
          if ($scope.campaign._id) {
            valid =
              $scope.creativesComplete &&
              $scope.inventoryComplete &&
              $scope.targetingComplete &&
              $scope.deliveryComplete &&
              $scope.basicsComplete;
          } else {
            valid =
              $scope.inventoryComplete &&
              $scope.targetingComplete &&
              $scope.deliveryComplete &&
              $scope.basicsComplete;
          }

          return valid;
        })();
      };

      var generateLeadTrackingUrl = function(lead, lead_index){
          var url = $scope.leadUrlPattern;
          url = url.replace(/\[lead_event\]/g, lead_index);
          url = url.replace(/\[lead_type\]/g, lead.type);
          url = url.replace(/\[lead_title\]/g, encodeURI(lead.title));
          if ($scope.campaign._id) {
              url = url.replace(/\[campaign_id\]/g, $scope.campaign._id);
          }
          lead.trackingUrl = url;
          return url;
      }

      $scope.$watch(
        'campaign',
        function(campaign) {
          validateCampaign();

          // total budget forecast
          $scope.totalCost = campaign.budget_total || 0;
          $scope.totalMinCPM = campaign.cpm_min || 0;
          $scope.totalMaxCPM = campaign.cpm_max || 0;

          if (!campaign) {
            return;
          }

          campaign.leads.forEach(function(lead, index) {
              lead.trackingUrl = generateLeadTrackingUrl(lead, index+1);
          });
          campaign.ileads.forEach(function(lead, index) {
                lead.trackingUrl = generateLeadTrackingUrl(lead, index+50);
            });

        },
        true
      );

      // get advertisers
      advertiserApi
        .getList(
          { field: 'name', order: 'asc' },
          '',
          { number: 0, size: -1 }
        )
        .then(
          function(advertisers) {
            $scope.advertisers = [];
            $scope.advertisers_full = [];

            advertisers.data.forEach(function(advertiser) {
              $scope.advertisers.push({
                name: advertiser.name,
                value: advertiser._id,
              });
              $scope.advertisers_full[advertiser._id] = advertiser;
            });
          },
          function() {
            console.error('could not load advertisers');
          }
        );


        // get agencies
        agencyApi
            .getList(
                { field: 'name', order: 'asc' },
                '',
                { number: 0, size: -1 }
            )
            .then(
                function(agencies) {
                    $scope.agencies = [
                        {name: "Unassigned", value: null}
                    ];

                    agencies.data.forEach(function(agency) {
                        $scope.agencies.push({
                            name: agency.name,
                            value: agency.id,
                        });
                    });
                },
                function() {
                    console.error('could not load agencies');
                }
            );


        // get account managers
        optionsApi
            .getAccountManagers()
            .then(
                function(users) {
                    $scope.accountManagers = [
                        {name: "Unassigned", value: null}
                    ];

                    users.data.forEach(function(accountManager) {
                        $scope.accountManagers.push({
                            name: accountManager.username,
                            value: accountManager.ID,
                        });
                    });
                },
                function() {
                    console.error('could not load accountManagers');
                }
            );

        $scope.quickComplete = function(name) {
            switch (name){
                case 'adomain':
                    if ($scope.campaign._insertionOrderId && $scope.io_full[$scope.campaign._insertionOrderId].adomain)
                        $scope.campaign.adomain = $scope.io_full[$scope.campaign._insertionOrderId].adomain;
                    else if ($scope.campaign._advertiserId && $scope.advertisers_full[$scope.campaign._advertiserId].url)
                        $scope.campaign.adomain = $scope.advertisers_full[$scope.campaign._advertiserId].url;
                    break;
                case 'logo':
                    if ($scope.campaign._insertionOrderId && $scope.io_full[$scope.campaign._insertionOrderId].logo)
                        $scope.campaign.logo = $scope.io_full[$scope.campaign._insertionOrderId].logo;
                    else if ($scope.campaign._advertiserId && $scope.advertisers_full[$scope.campaign._advertiserId].logo)
                        $scope.campaign.logo = $scope.advertisers_full[$scope.campaign._advertiserId].logo;
                    break;
                case 'iab_cat':
                    if ($scope.campaign._insertionOrderId && $scope.io_full[$scope.campaign._insertionOrderId].iab_category)
                        $scope.campaign.iab_category = $scope.io_full[$scope.campaign._insertionOrderId].iab_category;
                    else if ($scope.campaign._advertiserId && $scope.advertisers_full[$scope.campaign._advertiserId].iab_category)
                        $scope.campaign.iab_category = $scope.advertisers_full[$scope.campaign._advertiserId].iab_category;
                    break;
            }
        };

      $scope.cloneFromIo = function(data) {
        switch (data) {
          case 'dates':
            if (!$scope.startDisabled) {
              if ($scope.io.start < $scope.now) {
                $scope.campaign.start = $scope.now;
              } else {
                $scope.campaign.start = $scope.io.start;
              }
            }

            if (!$scope.endDisabled) {
              if ($scope.io.end < $scope.now) {
                // it's not possible to create a campaign in the past
                $scope.ioInvalid = 'The IO has expired. It\'s not possible to create a campaign.';
                $scope.ioExpired = true;
                disableDateChanging();
              }
              $scope.campaign.end = $scope.io.end;
            }
            break;
        }
      };

      $scope.speedList = 'wl';
      //$scope.osList = 'wl';
      //$scope.iabTopicIdList = 'wl';
      $scope.langList = 'wl';

      $scope.$watch('cntrList', function(newVal, oldVal) {
        if (newVal && oldVal) {
          $scope.campaign.country_blacklist = [];
          $scope.campaign.country_whitelist = [];
        }
      });


      $scope.$watch('regionList', function(newVal, oldVal) {
          if (newVal && oldVal) {
              $scope.campaign.region_blacklist = [];
              $scope.campaign.region_whitelist = [];
          }
      });

      $scope.$watch('cityList', function(newVal, oldVal) {
        if (newVal && oldVal) {
          $scope.campaign.city_blacklist = [];
          $scope.campaign.city_whitelist = [];
        }
      });

      $scope.$watch('zipList', function(newVal, oldVal) {
        if (newVal && oldVal) {
          $scope.campaign.zip_blacklist = [];
          $scope.campaign.zip_whitelist = [];
        }
      });

        $scope.$watch('dtaList', function(newVal, oldVal) {
            if (newVal && oldVal) {
                $scope.campaign.dta_profiles_blacklist = [];
                $scope.campaign.dta_profiles_whitelist = [];
            }
        });


        $scope.$watch('ispList', function(newVal, oldVal) {
        if (newVal && oldVal) {
          $scope.campaign.isp_blacklist = [];
          $scope.campaign.isp_whitelist = [];
        }
      });

      $scope.$watch('dayHourList', function(newVal, oldVal) {
        if (newVal && oldVal) {
            $scope.campaign.day_hour_whitelist = [];
            $scope.campaign.day_hour_blacklist = [];
        }
      });

        $scope.$watch('weekDayList', function(newVal, oldVal) {
            if (newVal && oldVal) {
                $scope.campaign.week_day_whitelist = [];
                $scope.campaign.week_day_blacklist = [];
            }
        });

        $scope.$watch('langList', function(newVal, oldVal) {
            if (newVal && oldVal) {
                $scope.campaign.lang_whitelist = [];
                $scope.campaign.lang_blacklist = [];
            }
        });

        $scope.$watch('osList', function(newVal, oldVal) {
            if (newVal && oldVal) {
                $scope.campaign.os_blacklist = [];
                $scope.campaign.os_whitelist = [];
            }
        });

        $scope.$watch('iabTopicIdList', function(newVal, oldVal) {
            if (newVal && oldVal) {
                $scope.campaign.iab_topic_id_whitelist = [];
                $scope.campaign.iab_topic_id_blacklist = [];
            }
        });


        $scope.setList = function(type) {
        switch (type) {
          case 'country':
            campaign.country_blacklist = [];
            campaign.country_whitelist = [];
            break;
          case 'region':
            campaign.region_blacklist = [];
            campaign.region_whitelist = [];
            break;
          case 'city':
            campaign.city_blacklist = [];
            campaign.city_whitelist = [];
            break;
          case 'zip':
            campaign.zip_blacklist = [];
            campaign.zip_whitelist = [];
            break;
          case 'lang':
            campaign.lang_blacklist = [];
            campaign.lang_whitelist = [];
            break;
          case 'dta':
            campaign.dta_profiles_blacklist = [];
            campaign.dta_profiles_whitelist = [];
            break;
        }
      };

      $scope.inventoryCovered = false;

      // check whether selected inventory covers every hour of the campaign
      $scope.$watch(
        'campaign.inventory',
        function(newVal) {
          validateInventory($scope.inventory, newVal);
          validateCampaign();
        },
        true
      );

      $scope.$watch('inventory', function(newVal) {
        validateInventory(newVal, $scope.campaign.inventory);
        validateCampaign();
      });

      var validateInventory = function(available, selected) {
        if (
          typeof available === 'undefined' ||
          typeof selected === 'undefined'
        ) {
          return;
        }

        var current = moment($scope.campaign.start),
          end = $scope.campaign.end / 1000;

        var items = [];
        available.forEach(function(item) {
          if (selected.indexOf(item.id) > -1) {
            items.push({
              id: item.id,
            });
          }
        });



        $scope.inventoryCovered = items.length > 0;
      };

      // try saving and process server side validation errors
      $scope.submitForm = function() {

        campaignApi.save($scope.campaign).then(
          function(campaignId) {
            if ($scope.closeCampaignForm) {
              $('#submit-modal').modal('hide');
              $('body').removeClass('modal-open');
              $('.modal-backdrop').remove();

              $window.location.href = '/#!/demandmgr/campaign';
            } else {
              $window.location.href =
                '/#!/demandmgr/campaign/edit?id=' + campaignId;
              $scope.msgSaved =
                'Campaign "' + $scope.campaign.name + '" has been saved';
            }
          },
          function(data) {
              defaultSaveErrorHandler($scope.campaignForm, data,
                  function(field, error){
                      if (field === 'inventory') {
                          $scope.invalidInventory = true;
                      }
                  }
              );
          }
        );
      };



      $scope.detectUnselectItems = function() {
          $scope.itemsSelectMode = true;
          $scope.inventory.forEach(function (item) {
              if ($scope.inventoryAdded(item)) {
                  $scope.itemsSelectMode = false;
                  return;
              }
          });
      }

      $scope.itemsSelectUnselect = function(){
            if ($scope.itemsSelectMode){
                $scope.inventory.forEach(function(item) {
                    if (!$scope.inventoryAdded(item)) {
                        $scope.toggleInventory(item);
                    }
                });
            } else {
                $scope.inventory.forEach(function(item) {
                    if ($scope.inventoryAdded(item)) {
                        $scope.toggleInventory(item);
                    }
                });
            }
          $scope.itemsSelectMode = !$scope.itemsSelectMode;

      };

      $scope.clusters = [];
      $scope.sources = [];
      $scope.creativeTypes = [];
      $scope.invClusterFilter = [];
      $scope.invSourceFilter = ['*'];
      $scope.invSearchFilter = '';
      $scope.adTypeFilter = ['*'];
      $scope.bookedFilter = ['booked'];
      $scope.bookedFilterTypes =  [
            {'name':'Booked','value': 'booked'},
            {'name':'Not-booked', 'value':'not-booked'}
      ];

      $scope.invSearchFilterKeyPress = function(e) {
        if (e.originalEvent.charCode === 13) {
            $scope.fetchInventory();
            e.preventDefault();
        }
       };


      if (!window.campaignId){
        $scope.bookedFilter.push('not-booked');
      }

      $scope.$watch("bookedFilter", function(newVal, oldVal) {
        if (newVal && oldVal && newVal != oldVal) {
            $scope.fetchInventory();
        }
      },true);


      optionsApi.getInventoryCreativeTypes().then(
          function(types) {
                $scope.creativeTypes = [];
                $scope.adTypeFilter = [];
                types.forEach(function (type) {
                    $scope.creativeTypes.push({name: type.name, value: type.value });
                    $scope.adTypeFilter.push(type.value);
                });
                $scope.$watch("adTypeFilter", function(newVal, oldVal) {
                    if (newVal && oldVal && newVal != oldVal) {
                        $scope.fetchInventory();
                    }
                },true);
          },
          function() {
              console.error('Could not load creative types');
          });

        optionsApi.getCampaignTypes().then(
            function(types) {
                $scope.campaignTypes = [];
                types.forEach(function (type) {
                    $scope.campaignTypes.push({name: type.name, value: type.value });
                });
            },
            function() {
                console.error('Could not load campaign types');
            });

        campaignApi.getInventoryClusters().then(
          function(clusters) {
            $scope.clusters = [];
            $scope.invClusterFilter = [];

            clusters.forEach(function(cluster) {
              $scope.clusters.push({
                name: cluster.name,
                value: cluster._id
              });
            });

             $scope.$watch("invClusterFilter", function(newVal, oldVal) {
               if (newVal && oldVal && newVal != oldVal) {
                 $scope.fetchInventory();
               }
             },true);
          },
          function() {
            console.error('Could not load inventory clusters');
          }
        );

        campaignApi.getInventorySources(true).then(
        function(sources) {
              $scope.sources = [];
              $scope.invSourceFilter = [];
              sources.forEach(function(source) {
                $scope.sources.push({
                  name: source.name,
                  value: source.id
                });
                // select all active
                  if (source.active == 1) {
                      $scope.invSourceFilter.push(source.id);
                  }
              });
              $scope.$watch("invSourceFilter", function(newVal, oldVal) {
                  if (newVal && oldVal && newVal != oldVal) {
                      $scope.fetchInventory();
                  }
              },true);
        },
        function() {
          console.error('Could not load inventory sources');
        }
      );

      $scope.fetchInventory = function() {
        $scope.inventoryLoading = true;
        // load inventory from server
        campaignApi
          .getInventoryItems(
            $scope.invSourceFilter,
            $scope.invClusterFilter,
            $scope.invSearchFilter,
            $scope.campaign.dvt_whitelist,
            $scope.adTypeFilter,
          )
          .then(
            function(inventory) {
              $scope.inventoryLoading = false;
              $scope.inventory = [];
              // only make items available that match at least partially
              inventory.forEach(function(item) {
                  if ( ($scope.bookedFilter.indexOf('booked') > -1 && $scope.inventoryAdded(item)) ||
                       ($scope.bookedFilter.indexOf('not-booked') > -1 && !$scope.inventoryAdded(item))
                  ){
                    $scope.inventory.push(item);
                  }

              });
              $scope.detectUnselectItems();
            },
            function() {
              $scope.inventoryLoading = false;
              console.error('could not load inventory');
            }
          );
      };

      $scope.fetchInventory();

      $scope.toggleInventory = function(item) {
        if ($scope.inventoryAdded(item)) {
          $scope.campaign.inventory.splice(
            $scope.campaign.inventory.indexOf(item.id),
            1
          );
        } else {
          $scope.campaign.inventory.push(item.id);
        }
      };
      $scope.inventoryAdded = function(item) {
        return $scope.campaign.inventory.indexOf(item.id) > -1;
      };

      $scope.checkInvDateRange = function(item) {
          return 'full';
      };

      /**
       * check if Campaign name is unique per advertiser
       * @return {boolean}
       */
      $scope.isNameUnique = function() {
        if ($scope.campaignForm && $scope.campaignForm.hasOwnProperty('name')) {
          console.log($scope.campaignForm['name'].$error.unique);
          var res = $scope.campaignForm['name'].$error.unique === undefined;
          console.log(res);
          return res;
        }

        return true;
      };

        /**
         * Add lead
         * @param leadData
         */
        $scope.addLead = function(leadData) {
            console.log("addLead", leadData);

            if(leadData === undefined){
                var leadData = {
                    'title': '',
                    'type': '0',
                    'callbackUrl':'',
                    'callbackCallType': '0',
                    'trackingUrl': ''
                };
            }

            leadData.trackingUrl = generateLeadTrackingUrl(leadData, $scope.campaign.leads.length+1);
            $scope.campaign.leads.push(leadData)
        };


        /**
         * removeLead
         * @param num
         */
        $scope.removeLead = function(num) {
            console.log("removeLead", num);
            $scope.campaign.leads.splice(num, 1);

        };

        /**
         * Add ILead
         * @param leadData
         */
        $scope.addILead = function(leadData) {
            console.log("addILead", leadData);

            if(leadData === undefined){
                var leadData = {
                    'title': '',
                    'type': '0',
                    'trackingUrl': $scope.leadUrlPattern
                };
            }
            leadData.trackingUrl = generateLeadTrackingUrl(leadData, $scope.campaign.ileads.length+50);

            $scope.campaign.ileads.push(leadData)
        };

        /**
         * removeILead
         * @param num
         */
        $scope.removeILead = function(num) {
            console.log("removeILead", num);
            $scope.campaign.ileads.splice(num, 1);

        };


        /**
         * copyLeadTrackingUrlToClipboard
         * @param num
         * @param type
         */
        $scope.copyLeadTrackingUrlToClipboard = function(num, type){

            var text = "";
            if (type == 'ilead'){
                text = $scope.campaign.ileads[num].trackingUrl;
            } else if (type == 'lead'){
                text = $scope.campaign.leads[num].trackingUrl;
            }
            var copyElement = document.createElement("textarea");
            copyElement.style.position = 'fixed';
            copyElement.style.opacity = '0';
            copyElement.textContent = text;
            var body = document.getElementsByTagName('body')[0];
            body.appendChild(copyElement);
            copyElement.select();
            document.execCommand('copy');
            body.removeChild(copyElement);
            alert("Tracking Url successfully copied to clipboard");
        }

        /**
       * display a warning if budget exceeds 1 Mio
       */
      $scope.promptSubmit = function() {
         !$scope.campaign.adomain && $scope.quickComplete('adomain');
         !$scope.campaign.logo && $scope.quickComplete('logo');
         !$scope.campaign.iab_category && $scope.quickComplete('iab_cat');

          if (!$scope.campaignForm.$valid){
              return;
          }

          if ($scope.cntrList === undefined ||
              ($scope.cntrList === 'wl' && $scope.campaign.country_whitelist.length === 0) ||
              ($scope.cntrList === 'bl' && $scope.campaign.country_blacklist.length === 0)
          ) {
              $('#whitelist-confirm').modal('show');
              return;
          }

          const MIO = 1000000;
          if ($scope.campaign.budget_daily > MIO ||$scope.campaign.budget_total > MIO) {
              $('#submit-modal').modal('show');
              return;
            }

          $scope.submitForm();
      };
    },
  ]);

  app.controller('CampaignEditCreativeController', [
    '$scope',
    '$http',
    function($scope, $http) {
      var fetch = function() {
        $http
          .get('/demandmgr/campaign/creative?campaignId=' + window.campaignId)
          .then(
            function(res) {
              $scope.creatives = res.data.data;
              $scope.$parent.creativesComplete = $scope.creatives.length > 0;
            },
            function() {
              console.error('could not load creatives');
            }
          );
      };

      if (window.campaignId) {
        fetch();
      }

      $scope.toggleCreative = function(creative) {
        $http.put('/demandmgr/creative/toggle-active?id=' + creative.id).then(
          // success
          function() {
            fetch();
          },
          // error
          function() {
            console.error('could not update creative');
          }
        );
      };
    },
  ]);
})(window.angular);
